export default __webpack_public_path__ + "static/media/spratt3.03786d34.jpg";